import { Translate } from '@/components';
import styles from './TagList.styles';

interface TagListProps {
  tags: Array<string>;
}

const TagList: React.FC<TagListProps> = ({ tags }) => (
  <div className={styles.container}>
    {tags.map(tag => (
      <span key={tag} className={styles.tag}>
        <Translate>{tag}</Translate>
      </span>
    ))}
  </div>
);

export default TagList;
